export const requiredFieldMessage = "This field is required.";
export const invalidFormatMessage = "Invalid format.";
